import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent {
  userDetails : any
constructor(public ref: DynamicDialogRef,
    public config: DynamicDialogConfig){
      console.log(this.config)
      this.userDetails = this.config?.data?.data
    }
}
